export default __webpack_public_path__ + "static/media/slider-img4.1cced44d.gif";